export const GET_CREDIT_MODEL_REPORT_REQUEST = 'GET_CREDIT_MODEL_REPORT_REQUEST';
export const GET_CREDIT_MODEL_REPORT_FAILURE = 'GET_CREDIT_MODEL_REPORT_FAILURE';
export const GET_CREDIT_MODEL_REPORT_SUCCESS = 'GET_CREDIT_MODEL_REPORT_SUCCESS';

export const GET_INTEGRATION_PROGRESS_REQUEST = 'GET_INTEGRATION_PROGRESS_REQUEST';
export const GET_INTEGRATION_PROGRESS_FAILURE = 'GET_INTEGRATION_PROGRESS_FAILURE';
export const GET_INTEGRATION_PROGRESS_SUCCESS = 'GET_INTEGRATION_PROGRESS_SUCCESS';
